/**
 * Плагин работы с объектами
 */

const obj = {
    /**
     * Возвращает истину если передаваемый параметр - пустой объект
     *
     * @param {object} obj Проверяемый объект
     */
    isEmpty (obj) {
        return obj == null || (
                obj // 👈 null and undefined check
                && Object.keys(obj).length === 0
                && Object.getPrototypeOf(obj) === Object.prototype
            );
    },
}

export default obj;
